module.exports = __webpack_public_path__ + "img/slots_online.cb829056.png";